import { Fragment } from 'react';
import { PRICING_RATES, formatPricingMoney } from '../pricingData';

export default function PricingSetupPrice({ locale, label }) {
  const rates = PRICING_RATES[locale === 'tr' ? 'tr' : 'en'];
  const current = formatPricingMoney(rates.setup, locale);
  const previous = formatPricingMoney(rates.setupOriginal, locale);
  const parts = label === undefined ? ['', ''] : label.split(current);

  return parts.map((part, index) => <Fragment key={index}>
    {index > 0 && <><s data-setup-original>{previous}</s>{' '}<strong data-setup-current>{current}</strong></>}
    {part}
  </Fragment>);
}
